import React, { useLayoutEffect } from 'react';
import { useEffect, useRef, useState } from 'react';
import {
  useBuyOrSellOptions,
  useDollarRange,
  useDollarRangeEnabled,
  useExpirationDates,
  useHugCurrentPrice,
  useHugCurrentPriceEnabled,
  useITM,
  useItm1,
  useItm1Enabled,
  useNotExpiringToday,
  useOptionChoices,
  useOptionManagement,
  useOptionPriceRange,
  useOptionPriceRangeEnabled,
  useOTM,
  useOtm1,
  useOtm1Enabled,
  useQtyRange,
  useQtyRangeEnabled,
  useTightSpreadCents,
  useTightSpreadCentsEnabled,
  useTightSpreadPct,
  useTightSpreadPctEnabled,
  useViewOptionManagementEnabled,
} from '../../../forms/tradeplans/tradingPlanFormComponents/hooks/optionmanagement/OptionManagmentHooks';
import useTopReducer from '../../../forms/tradeplans/tradingPlanFormComponents/hooks/topReducer';
import {
  useSetupDetails,
  useSetupFields,
  useSetupKey,
} from '../../../forms/tradeplans/tradingPlanFormComponents/hooks/setup/SetupHooks';
import {
  useEmaIntersectsFirstCandle,
  useEmaIntersectsFirstCandleEnabled,
  useFtfcFilter,
  useFtfcFilterEnabled,
  usePriceIntersectsFirstCandle,
  usePriceIntersectsFirstCandleEnabled,
  useSetupFilters,
  useTimeOfDay,
  useTimeOfDayEnabled,
} from '../../../forms/tradeplans/tradingPlanFormComponents/hooks/setupfilters/SetupFilterHooks';
import {
  useCandleBreak,
  useCandleBreakEnabled,
  useEntryTactics,
  useLimitOrder,
  useLimitOrderEnabled,
  useMarketOrder,
  useMarketOrderEnabled,
} from '../../../forms/tradeplans/tradingPlanFormComponents/hooks/tactics/EntryTacticHooks';
import {
  useAddToWinner,
  useAddToWinnerEnabled,
  usePositionTactics,
  useScalingIn,
  useScalingInEnabled,
} from '../../../forms/tradeplans/tradingPlanFormComponents/hooks/tactics/PositionTacticHooks';
import {
  useAtrTrail,
  useAtrTrailEnabled,
  useBreakPrice,
  useBreakPriceEnabled,
  useCandleMagnitude,
  useCandleMagnitudeEnabled,
  useCandleTrail,
  useCandleTrailEnabled,
  useExitTactics,
  useGrabCents,
  useGrabCentsDetails,
  useGrabCentsEnabled,
  useGrabCentsMode,
  useGreenToRedCandles,
  useGreenToRedCandlesEnabled,
  useGreenToRedPositions,
  useGreenToRedPositionsEnabled,
  useLossLimit,
  useLossLimitEnabled,
  useMfeRetracement,
  useMfeRetracementEnabled,
  usePositionBreakPrice,
  usePositionBreakPriceEnabled,
  usePositionPriceTrail,
  usePositionPriceTrailEnabled,
  usePreserveProfit,
  usePreserveProfitEnabled,
  useRatchetBracket,
  useRatchetBracketEnabled,
  useUnderlyingPriceExit,
  useUnderlyingPriceExitEnabled,
  useUnderlyingPriceTrail,
  useUnderlyingPriceTrailEnabled,
} from '../../../forms/tradeplans/tradingPlanFormComponents/hooks/tactics/ExitTacticHooks';
import useDataMemo from '../../../forms/tradeplans/tradingPlanFormComponents/hooks/useDataMemo';
import TradePlanSetup from './tradePlanSetup/TradePlanSetup';
import { useRestartSettings } from '../../../forms/tradeplans/tradingPlanFormComponents/hooks/restartsettings/RestartSettingsHooks';
import { isOptionInstrument } from '../activeTradePlanModule/utils/optionInstrument';

let prevValues = {};

export default function DisplayTradePlanSetup({
  userPreferences,
  index,
  deleteIndex,
}) {
  //const [finishedRenderingOptionChain, setFinishedRenderingOptionChain] = useState(true);
  /* const closeDrawer = (event) => {
         if (
             event.type === "keydown" &&
             (event.key === "Tab" || event.key === "Shift")
         ) {
             return;
         }
         setShowTpView(false);
     };*/
  /*let exitDrawerShortCut = "esc";

    let shortcutKeyActions = {
        [exitDrawerShortCut]: {
            action: () => {
                setShowTpView(false);
            },
        },
    };
*/
  /*
        const onKeyDown = (keyName, e, handle) => {
            shortcutKeyActions[keyName].action();
        };
    */
  //the following is all the code that goes into building the tradeplan form. so state could persist, it is now done at this level
  const [tpFormRendered, setTpFormRendered] = useState(false);
  if (!tpFormRendered) {
    prevValues = {};
    setTpFormRendered(true);
  }
  const [defaultQtyBasisValue, setDefaultQtyBasisValue] = useState(0);
  //console.log("qtybasis: " + defaultQtyBasisValue);
  const [selectAll, setSelectAll] = useState(false);
  const [callType, setCallType] = useState('none'); //none, front, all;
  const [putType, setPutType] = useState('none'); //none, front, all;
  let optionShortCutsPackage = [
    selectAll,
    setSelectAll,
    callType,
    setCallType,
    putType,
    setPutType,
  ];
  const [maxOptionPriceBarrier, setMaxOptionPriceBarrier] = useState('');
  const [minOptionPriceBarrier, setMinOptionPriceBarrier] = useState('');
  const [clickedSubmit, setClickedSubmit] = useState(false);
  const [submitMessageDetails, setSubmitMessageDetails] = useState({});
  const [storedConfigKey, setStoredConfigKey] = useState('');
  const [configTitle, setConfigTitle] = useState('');
  let packageOfSetters = [];
  const [symbolsUsed, setSymbolsUsed] = useState(1);
  const symbolsRemaining = useRef(0);
  packageOfSetters.push(setStoredConfigKey);
  packageOfSetters.push(setConfigTitle);

  const [restartSettings, setRestartSettings] = useRestartSettings();
  useEffect(() => {
    let rs = userPreferences['userPreferences']['restartSettings'];
    if (rs !== undefined) {
      setRestartSettings(rs);
    }
  }, [userPreferences['userPreferences']['restartSettings']]);

  packageOfSetters.push(setRestartSettings);

  //options management
  //option filters
  const IsUserPrefOptionFiltersEnabled = (strategy, setStrategyEnabled) => {
    return useEffect(() => {
      if (
        userPreferences['userPreferences']['optionManagement'][
          'optionFilters'
        ] !== undefined
      ) {
        setStrategyEnabled(
          userPreferences['userPreferences']['optionManagement'][
            'optionFilters'
          ][strategy] !== undefined
        );
      }
    }, [
      userPreferences['userPreferences']['optionManagement'][
        'optionFilters'
      ] !== undefined
        ? userPreferences['userPreferences']['optionManagement'][
            'optionFilters'
          ][strategy]
        : '',
    ]);
  };

  const [tightSpreadPctEnabled, setTightSpreadPctEnabled] =
    useTightSpreadPctEnabled();
  packageOfSetters.push(setTightSpreadPctEnabled);
  IsUserPrefOptionFiltersEnabled('tightSpreadPct', setTightSpreadPctEnabled);

  const [tightSpreadCentsEnabled, setTightSpreadCentsEnabled] =
    useTightSpreadCentsEnabled();
  packageOfSetters.push(setTightSpreadCentsEnabled);
  IsUserPrefOptionFiltersEnabled(
    'tightSpreadCents',
    setTightSpreadCentsEnabled
  );

  const [optionPriceRangeEnabled, setOptionPriceRangeEnabled] =
    useOptionPriceRangeEnabled();
  packageOfSetters.push(setOptionPriceRangeEnabled);
  IsUserPrefOptionFiltersEnabled(
    'optionPriceRange',
    setOptionPriceRangeEnabled
  );

  const [qtyRangeEnabled, setQtyRangeEnabled] = useQtyRangeEnabled();
  packageOfSetters.push(setQtyRangeEnabled);
  IsUserPrefOptionFiltersEnabled('qtyRange', setQtyRangeEnabled);

  const [dollarRangeEnabled, setDollarRangeEnabled] = useDollarRangeEnabled();
  packageOfSetters.push(setDollarRangeEnabled);
  IsUserPrefOptionFiltersEnabled('dollarRange', setDollarRangeEnabled);

  const SetUserPrefOptionFilters = (strategy, dispatchStrategy) => {
    return useEffect(() => {
      dispatchStrategy(
        userPreferences['userPreferences']['optionManagement']['optionFilters'][
          strategy
        ]
      );
    }, [
      userPreferences['userPreferences']['optionManagement'][
        'optionFilters'
      ] !== undefined &&
      userPreferences['userPreferences']['optionManagement']['optionFilters'][
        strategy
      ] !== undefined
        ? userPreferences['userPreferences']['optionManagement'][
            'optionFilters'
          ][strategy]
        : '',
    ]);
  };

  const [tightSpreadPct, dispatchTightSpreadPct] = useTightSpreadPct();
  packageOfSetters.push(dispatchTightSpreadPct);
  SetUserPrefOptionFilters('tightSpreadPct', dispatchTightSpreadPct);

  const [tightSpreadCents, dispatchTightSpreadCents] = useTightSpreadCents();
  packageOfSetters.push(dispatchTightSpreadCents);
  SetUserPrefOptionFilters('tightSpreadCents', dispatchTightSpreadCents);

  const [optionPriceRange, dispatchOptionPriceRange] = useOptionPriceRange();
  packageOfSetters.push(dispatchOptionPriceRange);
  SetUserPrefOptionFilters('optionPriceRange', dispatchOptionPriceRange);

  const [qtyRange, dispatchQtyRange] = useQtyRange();
  packageOfSetters.push(dispatchQtyRange);
  SetUserPrefOptionFilters('qtyRange', dispatchQtyRange);

  const [dollarRange, dispatchDollarRange] = useDollarRange();
  packageOfSetters.push(dispatchDollarRange);
  SetUserPrefOptionFilters('dollarRange', dispatchDollarRange);

  //optionChoices
  const [optionChoices, setOptionChoices] = useOptionChoices();
  packageOfSetters.push(setOptionChoices);
  const [optionChains, setOptionChains] = useState({});
  packageOfSetters.push(setOptionChains);
  //optionChainStrategy
  const IsUserPrefOptionChainStrategyEnabled = (
    strategy,
    setStrategyEnabled
  ) => {
    return useEffect(() => {
      let hasStrategy =
        userPreferences['userPreferences']['optionManagement'][
          'optionChainStrategy'
        ][strategy] !== undefined;
      setStrategyEnabled(hasStrategy);
    }, [
      userPreferences['userPreferences']['optionManagement'][
        'optionChainStrategy'
      ] !== undefined
        ? userPreferences['userPreferences']['optionManagement'][
            'optionChainStrategy'
          ]
        : '',
    ]);
  };
  const [hugCurrentPriceEnabled, setHugCurrentPriceEnabled] =
    useHugCurrentPriceEnabled();
  packageOfSetters.push(setHugCurrentPriceEnabled);
  IsUserPrefOptionChainStrategyEnabled(
    'hugCurrentPrice',
    setHugCurrentPriceEnabled
  );

  const [otm1Enabled, setOtm1Enabled] = useOtm1Enabled();
  packageOfSetters.push(setOtm1Enabled);
  IsUserPrefOptionChainStrategyEnabled('OTM1', setOtm1Enabled);

  const [itm1Enabled, setItm1Enabled] = useItm1Enabled();
  packageOfSetters.push(setItm1Enabled);
  IsUserPrefOptionChainStrategyEnabled('ITM1', setItm1Enabled);

  const SetUserPrefOptionChainStrategy = (strategy, dispatchStrategy) => {
    return useEffect(() => {
      dispatchStrategy(
        userPreferences['userPreferences']['optionManagement'][
          'optionChainStrategy'
        ][strategy]
      );
    }, [
      userPreferences['userPreferences']['optionManagement'][
        'optionChainStrategy'
      ] !== undefined
        ? userPreferences['userPreferences']['optionManagement'][
            'optionChainStrategy'
          ][strategy]
        : '',
    ]);
  };

  const [hugCurrentPrice, dispatchHugCurrentPrice] = useHugCurrentPrice();
  packageOfSetters.push(dispatchHugCurrentPrice);
  SetUserPrefOptionChainStrategy('hugCurrentPrice', dispatchHugCurrentPrice);

  const [otm1, dispatchOtm1] = useOtm1();
  packageOfSetters.push(dispatchOtm1);
  SetUserPrefOptionChainStrategy('OTM1', dispatchOtm1);

  const [itm1, dispatchItm1] = useItm1();
  packageOfSetters.push(dispatchItm1);
  SetUserPrefOptionChainStrategy('ITM1', dispatchItm1);

  //option management

  const SetOptionField = (field, setter) => {
    return useEffect(() => {
      let t = userPreferences['userPreferences']['optionManagement'][field];
      setter(t);
    }, [
      userPreferences['userPreferences']['optionManagement'] !== undefined
        ? userPreferences['userPreferences']['optionManagement'][field]
        : '',
    ]);
  };
  const [viewOptionManagementEnabled, setViewOptionManagementEnabled] =
    useViewOptionManagementEnabled();
  packageOfSetters.push(setViewOptionManagementEnabled);

  const [expirationDates, setExpirationDates] = useExpirationDates();
  const [buyOrSellOption, setBuyOrSellOption] = useBuyOrSellOptions();
  packageOfSetters.push(setBuyOrSellOption);
  SetOptionField('buyOrSellOption', setBuyOrSellOption);

  const [otm, setOtm] = useOTM();
  packageOfSetters.push(setOtm);
  SetOptionField('OTM', setOtm);

  const [itm, setItm] = useITM();
  packageOfSetters.push(setItm);
  SetOptionField('ITM', setItm);

  const [notExpiringToday, setNotExpiringToday] = useNotExpiringToday(); //this is ONLY so frontend can use this. no need to pass to backend. will be set to undefined before sending
  packageOfSetters.push(setNotExpiringToday);
  SetOptionField('notExpiringToday', setNotExpiringToday);

  const optionManagement = useOptionManagement(
    [hugCurrentPriceEnabled, setHugCurrentPriceEnabled],
    [tightSpreadPctEnabled, setTightSpreadPctEnabled],
    [tightSpreadCentsEnabled, setTightSpreadCentsEnabled],
    [optionPriceRangeEnabled, setOptionPriceRangeEnabled],
    [qtyRangeEnabled, setQtyRangeEnabled],
    [dollarRangeEnabled, setDollarRangeEnabled],
    [hugCurrentPrice, dispatchHugCurrentPrice],
    [tightSpreadPct, dispatchTightSpreadPct],
    [tightSpreadCents, dispatchTightSpreadCents],
    [optionPriceRange, dispatchOptionPriceRange],
    [qtyRange, dispatchQtyRange],
    [dollarRange, dispatchDollarRange],
    [expirationDates, setExpirationDates],
    [buyOrSellOption, setBuyOrSellOption],
    [otm, setOtm],
    [itm, setItm],
    [notExpiringToday, setNotExpiringToday],
    [optionChoices, setOptionChoices],
    [otm1Enabled, setOtm1Enabled],
    [otm1, dispatchOtm1],
    [itm1Enabled, setItm1Enabled],
    [itm1, dispatchItm1]
  );

  const [top, dispatchTop] = useTopReducer();

  const SetTopFieldsFromUserPreferences = (field) => {
    return useEffect(() => {
      let storedField =
        userPreferences['userPreferences']['tradePlanConfig'][field];
      //console.log(field + ": " + storedField);
      //       console.log("running user pref on field: " + field + ". setting to: " + storedField)
      if (storedField !== undefined) {
        dispatchTop({ [field]: storedField });
      }
      //  console.log(top);
    }, [userPreferences['userPreferences']['tradePlanConfig'][field]]);
  };
  //console.log(userPreferences);
  packageOfSetters.push(dispatchTop);
  SetTopFieldsFromUserPreferences('dataSource');
  SetTopFieldsFromUserPreferences('brokerage');
  SetTopFieldsFromUserPreferences('accountNumber');
  SetTopFieldsFromUserPreferences('flattenAtMarketClose');
  SetTopFieldsFromUserPreferences('quantityBasis');
  SetTopFieldsFromUserPreferences('workOrders');
  SetTopFieldsFromUserPreferences('workOrdersOnEntry');
  SetTopFieldsFromUserPreferences('workOrdersOnExit');
  SetTopFieldsFromUserPreferences('getAwayOffsetPct');
  SetTopFieldsFromUserPreferences('pctBetweenBidAsk');
  SetTopFieldsFromUserPreferences('pctIncreasePerOrderAttempt');
  SetTopFieldsFromUserPreferences('getAwayOffsetPctOnExit');
  SetTopFieldsFromUserPreferences('pctBetweenBidAskOnExit');
  SetTopFieldsFromUserPreferences('pctIncreasePerOrderAttemptOnExit');
  SetTopFieldsFromUserPreferences('getAwayOffsetPctOnTarget');
  SetTopFieldsFromUserPreferences('pctBetweenBidAskOnTarget');
  SetTopFieldsFromUserPreferences('pctIncreasePerOrderAttemptOnTarget');
  SetTopFieldsFromUserPreferences('instrument');
  SetTopFieldsFromUserPreferences('evaluateQuotes');
  SetTopFieldsFromUserPreferences(
    'persistTradePlanOnFailedFiltersOrValidation'
  );
  //console.log(top);
  if (isOptionInstrument(top.instrument) && !viewOptionManagementEnabled) {
    setViewOptionManagementEnabled(true);
  }
  //setup
  const [setupFields, dispatchSetUpDetails] = useSetupFields();
  packageOfSetters.push(dispatchSetUpDetails);

  const setupKey = useSetupKey([top, dispatchTop]);

  const setupDetails = useSetupDetails([top, dispatchTop], setupKey, [
    setupFields,
    dispatchSetUpDetails,
  ]);
  //setup filters
  const [
    priceIntersectsFirstCandleEnabled,
    setPriceIntersectsFirstCandleEnabled,
  ] = usePriceIntersectsFirstCandleEnabled();
  packageOfSetters.push(setPriceIntersectsFirstCandleEnabled);

  const [priceIntersectsFirstCandle, dispatchPriceIntersectsFirstCandle] =
    usePriceIntersectsFirstCandle();
  packageOfSetters.push(dispatchPriceIntersectsFirstCandle);

  const [emaIntersectsFirstCandleEnabled, setEmaIntersectsFirstCandleEnabled] =
    useEmaIntersectsFirstCandleEnabled();
  packageOfSetters.push(setEmaIntersectsFirstCandleEnabled);

  const [emaIntersectsFirstCandle, dispatchEmaIntersectsFirstCandle] =
    useEmaIntersectsFirstCandle();
  packageOfSetters.push(dispatchEmaIntersectsFirstCandle);

  const [timeOfDayEnabled, setTimeOfDayEnabled] = useTimeOfDayEnabled();
  packageOfSetters.push(setTimeOfDayEnabled);

  const [timeOfDay, dispatchTimeOfDay] = useTimeOfDay();
  packageOfSetters.push(dispatchTimeOfDay);

  const [ftfcFilterEnabled, setFtfcFilterEnabled] = useFtfcFilterEnabled();
  packageOfSetters.push(setFtfcFilterEnabled);

  const [ftfcFilter, dispatchFtfcFilter] = useFtfcFilter();
  packageOfSetters.push(dispatchFtfcFilter);

  const setupFilters = useSetupFilters(
    [priceIntersectsFirstCandleEnabled, setPriceIntersectsFirstCandleEnabled],
    [priceIntersectsFirstCandle, dispatchPriceIntersectsFirstCandle],
    [emaIntersectsFirstCandleEnabled, setEmaIntersectsFirstCandleEnabled],
    [emaIntersectsFirstCandle, dispatchEmaIntersectsFirstCandle],
    [timeOfDayEnabled, setTimeOfDayEnabled],
    [timeOfDay, dispatchTimeOfDay],
    [ftfcFilterEnabled, setFtfcFilterEnabled],
    [ftfcFilter, dispatchFtfcFilter]
  );
  // Entry Tactics
  const [marketOrderEnabled, setMarketOrderEnabled] = useMarketOrderEnabled();
  packageOfSetters.push(setMarketOrderEnabled);
  const [limitOrderEnabled, setLimitOrderEnabled] = useLimitOrderEnabled();
  packageOfSetters.push(setLimitOrderEnabled);
  const [candleBreakEnabled, setCandleBreakEnabled] = useCandleBreakEnabled();
  packageOfSetters.push(setCandleBreakEnabled);

  const [marketOrder, dispatchMarketOrder] = useMarketOrder();
  packageOfSetters.push(dispatchMarketOrder);
  const [limitOrder, dispatchLimitOrder] = useLimitOrder();
  packageOfSetters.push(dispatchLimitOrder);
  const [candleBreak, dispatchCandleBreak] = useCandleBreak();
  packageOfSetters.push(dispatchCandleBreak);

  let storedEntryConfigurations =
    userPreferences['userPreferences']['tradePlanDefaultEntryTactics'];

  const EntryTacticUseEffectFactory = (tactic, field, setter) => {
    return useEffect(() => {
      if (storedEntryConfigurations[tactic] !== undefined) {
        setter(storedEntryConfigurations[tactic][field]);
      }
    }, [
      storedEntryConfigurations[tactic][field] !== undefined
        ? storedEntryConfigurations[tactic][field]
        : '',
    ]);
  };
  EntryTacticUseEffectFactory('marketOrder', 'enabled', setMarketOrderEnabled);
  EntryTacticUseEffectFactory('limitOrder', 'enabled', setLimitOrderEnabled);
  EntryTacticUseEffectFactory('limitOrder', 'offset', (o) =>
    dispatchLimitOrder({ offsetFromSetupPrice: o })
  );
  EntryTacticUseEffectFactory('limitOrder', 'limitPrice', (o) =>
    dispatchLimitOrder({ limitPrice: o })
  );
  EntryTacticUseEffectFactory(
    'limitOrder',
    'setLimitFromSetupBreakPrice',
    (s) => dispatchLimitOrder({ setLimitFromSetupBreakPrice: s })
  );
  EntryTacticUseEffectFactory('candleBreak', 'enabled', setCandleBreakEnabled);
  EntryTacticUseEffectFactory('candleBreak', 'candleDuration', (cd) =>
    dispatchCandleBreak({ candleDuration: cd })
  );
  EntryTacticUseEffectFactory(
    'candleBreak',
    'waitUntilCurrentCandleCloses',
    (w) => dispatchCandleBreak({ waitUntilCurrentCandleCloses: w })
  );
  EntryTacticUseEffectFactory('candleBreak', 'breakBy', (si) =>
    dispatchCandleBreak({ breakBy: si })
  );

  useEffect(() => {
    if (storedEntryConfigurations !== undefined) {
      //if (!settingDefaultConfig) {
      //       console.log("running qty basis value use effect: ");
      let storedQtyBasisValues = storedEntryConfigurations['qtyBasisValues'];
      let isOption = isOptionInstrument(top.instrument);
      let isQty = top.quantityBasis === 'QUANTITY';
      //    console.log(top);
      //    console.log(isOption);
      //   console.log(isQty);
      let qtyBasisValue = 0;
      if (storedQtyBasisValues !== undefined) {
        if (isOption) {
          if (isQty) {
            qtyBasisValue = storedQtyBasisValues['qtyOption'];
          } else {
            //        console.log("is dlr option")
            qtyBasisValue = storedQtyBasisValues['dollarOption'];
          }
        } else {
          if (isQty) {
            qtyBasisValue = storedQtyBasisValues['qtyStock'];
          } else {
            qtyBasisValue = storedQtyBasisValues['dollarStock'];
          }
        }
        dispatchMarketOrder({ quantityBasisValue: qtyBasisValue });
        dispatchLimitOrder({ quantityBasisValue: qtyBasisValue });
        dispatchCandleBreak({ quantityBasisValue: qtyBasisValue });
        //   console.log("bottom of use effect: " + qtyBasisValue);
        setDefaultQtyBasisValue(qtyBasisValue);
      }
      //}
    }
  }, [
    storedEntryConfigurations.qtyBasisValues,
    top.instrument,
    top.quantityBasis,
  ]); //, top.instrument, top.quantityBasis]);
  //console.log(top);
  //useEffect(() => {
  //   if (doneSettingDefaultConfig) {
  //     setSettingDefaultConfig(false);
  //   setDoneSettingDefaultConfig(false);
  //}
  //}, [doneSettingDefaultConfig])

  const entryTactics = useEntryTactics(
    [marketOrderEnabled, setMarketOrderEnabled],
    [marketOrder, dispatchMarketOrder],
    [limitOrderEnabled, setLimitOrderEnabled],
    [limitOrder, dispatchLimitOrder],
    [candleBreakEnabled, setCandleBreakEnabled],
    [candleBreak, dispatchCandleBreak]
  );
  //position tactics
  const [scalingInEnabled, setScalingInEnabled] = useScalingInEnabled();
  packageOfSetters.push(setScalingInEnabled);
  const [addToWinnerEnabled, setAddToWinnerEnabled] = useAddToWinnerEnabled();
  packageOfSetters.push(setAddToWinnerEnabled);

  const [scalingIn, dispatchScalingIn] = useScalingIn();
  packageOfSetters.push(dispatchScalingIn);
  const [addToWinner, dispatchAddToWinner] = useAddToWinner();
  packageOfSetters.push(dispatchAddToWinner);

  const positionTactics = usePositionTactics(
    [scalingInEnabled, setScalingInEnabled],
    [addToWinnerEnabled, setAddToWinnerEnabled],
    [scalingIn, dispatchScalingIn],
    [addToWinner, dispatchAddToWinner]
  );

  const IsUserPreferenceExitTacticsEnabled = (tactic, setTacticEnabled) => {
    useEffect(() => {
      let hasTactic =
        userPreferences['userPreferences'].exitTactics[tactic] !== undefined;
      setTacticEnabled(hasTactic);
    }, [userPreferences['userPreferences'].exitTactics[tactic]]);
  };

  const [lossLimitEnabled, setLossLimitEnabled] = useLossLimitEnabled();
  IsUserPreferenceExitTacticsEnabled('LOSS_LIMIT', setLossLimitEnabled);
  packageOfSetters.push(setLossLimitEnabled);

  const [preserveProfitEnabled, setPreserveProfitEnabled] =
    usePreserveProfitEnabled();
  IsUserPreferenceExitTacticsEnabled(
    'PRESERVE_PROFIT',
    setPreserveProfitEnabled
  );
  packageOfSetters.push(setPreserveProfitEnabled);

  const [positionPriceTrailEnabled, setPositionPriceTrailEnabled] =
    usePositionPriceTrailEnabled();
  IsUserPreferenceExitTacticsEnabled(
    'POSITION_PRICE_TRAIL',
    setPositionPriceTrailEnabled
  );
  packageOfSetters.push(setPositionPriceTrailEnabled);

  const [underlyingPriceTrailEnabled, setUnderlyingPriceTrailEnabled] =
    useUnderlyingPriceTrailEnabled();
  IsUserPreferenceExitTacticsEnabled(
    'UNDERLYING_PRICE_TRAIL',
    setUnderlyingPriceTrailEnabled
  );
  packageOfSetters.push(setUnderlyingPriceTrailEnabled);

  const [candleTrailEnabled, setCandleTrailEnabled] = useCandleTrailEnabled();
  IsUserPreferenceExitTacticsEnabled('CANDLE_TRAIL', setCandleTrailEnabled);
  packageOfSetters.push(setCandleTrailEnabled);

  const [atrTrailEnabled, setAtrTrailEnabled] = useAtrTrailEnabled();
  IsUserPreferenceExitTacticsEnabled('ATR_TRAIL', setAtrTrailEnabled);
  packageOfSetters.push(setAtrTrailEnabled);

  const [mfeRetracementEnabled, setMfeRetracementEnabled] =
    useMfeRetracementEnabled();
  IsUserPreferenceExitTacticsEnabled(
    'MFE_RETRACEMENT',
    setMfeRetracementEnabled
  );
  packageOfSetters.push(setMfeRetracementEnabled);

  const [grabCentsEnabled, setGrabCentsEnabled] = useGrabCentsEnabled();
  IsUserPreferenceExitTacticsEnabled('GRAB_CENTS', setGrabCentsEnabled);
  packageOfSetters.push(setGrabCentsEnabled);

  const [ratchetBracketEnabled, setRatchetBracketEnabled] =
    useRatchetBracketEnabled();
  IsUserPreferenceExitTacticsEnabled(
    'RATCHET_BRACKET',
    setRatchetBracketEnabled
  );
  packageOfSetters.push(setRatchetBracketEnabled);

  const [greenToRedCandlesEnabled, setGreenToRedCandlesEnabled] =
    useGreenToRedCandlesEnabled();
  IsUserPreferenceExitTacticsEnabled(
    'GREEN_TO_RED_CANDLES',
    setGreenToRedCandlesEnabled
  );
  packageOfSetters.push(setGreenToRedCandlesEnabled);

  const [greenToRedPositionsEnabled, setGreenToRedPositionsEnabled] =
    useGreenToRedPositionsEnabled();
  IsUserPreferenceExitTacticsEnabled(
    'GREEN_TO_RED_POSITIONS',
    setGreenToRedPositionsEnabled
  );
  packageOfSetters.push(setGreenToRedPositionsEnabled);

  const [breakPriceEnabled, setBreakPriceEnabled] = useBreakPriceEnabled();
  IsUserPreferenceExitTacticsEnabled('BREAK_PRICE', setBreakPriceEnabled);
  packageOfSetters.push(setBreakPriceEnabled);

  const [positionBreakPriceEnabled, setPositionBreakPriceEnabled] =
    usePositionBreakPriceEnabled();
  IsUserPreferenceExitTacticsEnabled(
    'POSITION_BREAK_PRICE',
    setPositionBreakPriceEnabled
  );
  packageOfSetters.push(setPositionBreakPriceEnabled);

  const [candleMagnitudeEnabled, setCandleMagnitudeEnabled] =
    useCandleMagnitudeEnabled();
  IsUserPreferenceExitTacticsEnabled(
    'CANDLE_MAGNITUDE',
    setCandleMagnitudeEnabled
  );
  packageOfSetters.push(setCandleMagnitudeEnabled);

  const [underlyingPriceExitEnabled, setUnderlyingPriceExitEnabled] =
    useUnderlyingPriceExitEnabled();
  IsUserPreferenceExitTacticsEnabled(
    'UNDERLYING_PRICE_EXIT',
    setUnderlyingPriceExitEnabled
  );
  packageOfSetters.push(setUnderlyingPriceExitEnabled);

  const SetUserPreferenceExitTacticFields = (tactic, dispatchTactic) => {
    useEffect(() => {
      let t = userPreferences['userPreferences'].exitTactics[tactic];
      for (let field in t) {
        if (t.hasOwnProperty(field)) {
          dispatchTactic({ [field]: t[field] });
        }
      }
    }, [userPreferences['userPreferences'].exitTactics[tactic]]);
  };
  const [grabCentsMode, setGrabCentsMode] = useGrabCentsMode();
  if (userPreferences['exitTactics'].grabCentsMode !== undefined) {
    if (userPreferences['exitTactics'].grabCentsMode === 'quantity') {
      if (prevValues['GRAB_CENTS_MODE'] !== 'quantity') {
        prevValues['GRAB_CENTS_MODE'] = 'quantity';
        setGrabCentsMode('quantity');
      }
    } else if (userPreferences['exitTactics'].grabCentsMode === 'percentage') {
      if (prevValues['GRAB_CENTS_MODE'] !== 'percentage') {
        prevValues['GRAB_CENTS_MODE'] = 'percentage';
        setGrabCentsMode('percentage');
      }
    }
  }
  packageOfSetters.push(setGrabCentsMode);

  const [ratchetBracket, dispatchRatchetBracket] = useRatchetBracket();
  SetUserPreferenceExitTacticFields('RATCHET_BRACKET', dispatchRatchetBracket);
  packageOfSetters.push(dispatchRatchetBracket);

  const [lossLimit, dispatchLossLimit] = useLossLimit();
  SetUserPreferenceExitTacticFields('LOSS_LIMIT', dispatchLossLimit);
  packageOfSetters.push(dispatchLossLimit);

  const [preserveProfit, dispatchPreserveProfit] = usePreserveProfit();
  SetUserPreferenceExitTacticFields('PRESERVE_PROFIT', dispatchPreserveProfit);
  packageOfSetters.push(dispatchPreserveProfit);

  const [positionPriceTrail, dispatchPositionPriceTrail] =
    usePositionPriceTrail();
  SetUserPreferenceExitTacticFields(
    'POSITION_PRICE_TRAIL',
    dispatchPositionPriceTrail
  );
  packageOfSetters.push(dispatchPositionPriceTrail);

  const [underlyingPriceTrail, dispatchUnderlyingPriceTrail] =
    useUnderlyingPriceTrail();
  SetUserPreferenceExitTacticFields(
    'UNDERLYING_PRICE_TRAIL',
    dispatchUnderlyingPriceTrail
  );
  packageOfSetters.push(dispatchUnderlyingPriceTrail);

  const [candleTrail, dispatchCandleTrail] = useCandleTrail();
  SetUserPreferenceExitTacticFields('CANDLE_TRAIL', dispatchCandleTrail);
  packageOfSetters.push(dispatchCandleTrail);

  const [atrTrail, dispatchAtrTrail] = useAtrTrail();
  SetUserPreferenceExitTacticFields('ATR_TRAIL', dispatchAtrTrail);
  packageOfSetters.push(dispatchAtrTrail);

  const [mfeRetracement, dispatchMfeRetracement] = useMfeRetracement();
  SetUserPreferenceExitTacticFields('MFE_RETRACEMENT', dispatchMfeRetracement);
  packageOfSetters.push(dispatchMfeRetracement);

  const [grabCents, dispatchGrabCents] = useGrabCents();
  SetUserPreferenceExitTacticFields('GRAB_CENTS', dispatchGrabCents);
  packageOfSetters.push(dispatchGrabCents);

  const [greenToRedCandles, dispatchGreenToRedCandles] = useGreenToRedCandles();
  SetUserPreferenceExitTacticFields(
    'GREEN_TO_RED_CANDLES',
    dispatchGreenToRedCandles
  );
  packageOfSetters.push(dispatchGreenToRedCandles);
  const [greenToRedPositions, dispatchGreenToRedPositions] =
    useGreenToRedPositions();
  SetUserPreferenceExitTacticFields(
    'GREEN_TO_RED_POSITIONS',
    dispatchGreenToRedPositions
  );
  packageOfSetters.push(dispatchGreenToRedPositions);

  const [breakPrice, dispatchBreakPrice] = useBreakPrice();
  SetUserPreferenceExitTacticFields('BREAK_PRICE', dispatchBreakPrice);
  packageOfSetters.push(dispatchBreakPrice);

  const [positionBreakPrice, dispatchPositionBreakPrice] =
    usePositionBreakPrice();
  SetUserPreferenceExitTacticFields(
    'POSITION_BREAK_PRICE',
    dispatchPositionBreakPrice
  );
  packageOfSetters.push(dispatchPositionBreakPrice);

  const [underlyingPriceExit, dispatchUnderlyingPriceExit] =
    useUnderlyingPriceExit();
  SetUserPreferenceExitTacticFields(
    'UNDERLYING_PRICE_EXIT',
    dispatchUnderlyingPriceExit
  );
  packageOfSetters.push(dispatchUnderlyingPriceExit);

  const [candleMagnitude, dispatchCandleMagnitude] = useCandleMagnitude();
  SetUserPreferenceExitTacticFields(
    'CANDLE_MAGNITUDE',
    dispatchCandleMagnitude
  );
  packageOfSetters.push(dispatchCandleMagnitude);

  const grabCentsDetails = useGrabCentsDetails(
    [grabCents, dispatchGrabCents],
    [grabCentsMode, setGrabCentsMode]
  );

  const exitTactics = useExitTactics(
    [lossLimitEnabled, setLossLimitEnabled],
    [lossLimit, dispatchLossLimit],
    [preserveProfitEnabled, setPreserveProfitEnabled],
    [preserveProfit, dispatchPreserveProfit],
    [positionPriceTrailEnabled, setPositionPriceTrailEnabled],
    [positionPriceTrail, dispatchPositionPriceTrail],
    [underlyingPriceTrailEnabled, setUnderlyingPriceTrailEnabled],
    [underlyingPriceTrail, dispatchUnderlyingPriceTrail],
    [grabCentsEnabled, setGrabCentsEnabled],
    [grabCents, dispatchGrabCents],
    grabCentsDetails,
    [ratchetBracketEnabled, setRatchetBracketEnabled],
    [ratchetBracket, dispatchRatchetBracket],
    [candleTrailEnabled, setCandleTrailEnabled],
    [candleTrail, dispatchCandleTrail],
    [greenToRedCandlesEnabled, setGreenToRedCandlesEnabled],
    [greenToRedPositionsEnabled, setGreenToRedPositionsEnabled],
    [greenToRedCandles, dispatchGreenToRedCandles],
    [greenToRedPositions, dispatchGreenToRedPositions],
    [breakPriceEnabled, setBreakPriceEnabled],
    [breakPrice, dispatchBreakPrice],
    [positionBreakPriceEnabled, setPositionBreakPriceEnabled],
    [positionBreakPrice, dispatchPositionBreakPrice],
    [candleMagnitudeEnabled, setCandleMagnitudeEnabled],
    [candleMagnitude, dispatchCandleMagnitude],
    [atrTrailEnabled, setAtrTrailEnabled],
    [atrTrail, dispatchAtrTrail],
    [mfeRetracementEnabled, setMfeRetracementEnabled],
    [mfeRetracement, dispatchMfeRetracement],
    [underlyingPriceExitEnabled, setUnderlyingPriceExitEnabled],
    [underlyingPriceExit, dispatchUnderlyingPriceExit]
  );
  //const [letEnterNowKnowOptionsDone, setLetEnterNowKnowOptionsDone] = useState(false);
  //option radio button
  useEffect(() => {
    console.log('calling option useEffect');
    let defaultOptionRadio =
      userPreferences['userPreferences']['optionRadioButtons'];
    if (
      defaultOptionRadio !== undefined &&
      defaultOptionRadio !== 'none' &&
      isOptionInstrument(top.instrument)
    ) {
      if (top.goLong && top.goShort) {
        setCallType(defaultOptionRadio);
        setPutType(defaultOptionRadio);
      } else {
        if (buyOrSellOption === 'LONG') {
          if (top.goLong) {
            //select calls
            setCallType(defaultOptionRadio);
            setPutType('none');
          } else if (top.goShort) {
            //select puts
            setPutType(defaultOptionRadio);
            setCallType('none');
          }
        } else {
          if (top.goLong) {
            setPutType(defaultOptionRadio);
            setCallType('none');
          } else if (top.goShort) {
            //select calls
            setCallType(defaultOptionRadio);
            setPutType('none');
          }
        }
      }
    }
    //setLetEnterNowKnowOptionsDone(true);
  }, [
    userPreferences['userPreferences']['optionRadioButtons'],
    top.goLong,
    top.goShort,
    buyOrSellOption,
    top.instrument,
  ]);

  const data = useDataMemo(
    top,
    optionManagement,
    viewOptionManagementEnabled,
    entryTactics,
    positionTactics,
    exitTactics,
    setupFilters,
    setupFields,
    setupDetails,
    restartSettings
  );

  useEffect(() => {
    if (top.instrument === 'stock' && underlyingPriceTrailEnabled) {
      setUnderlyingPriceTrailEnabled(false);
    }
  }, [top.instrument]);

  const mutableSymbol = useRef('');
  const savedConfigurations = useRef({});
  const [updatedSavedTp, setUpdatedSavedTp] = useState(false);

  const [selectedSavedConfig, setSelectedSavedConfig] = useState(false);
  useEffect(() => {
    if (
      configTitle === undefined ||
      configTitle === null ||
      configTitle === ''
    ) {
      setSelectedSavedConfig(false);
    }
  }, [configTitle]);

  const [savedConfigChanged, setSavedConfigChanged] = useState(false);
  //console.log(optionShortCutsPackage);
  return (
    <TradePlanSetup
      top={top}
      dispatchTop={dispatchTop}
      componentSymbol={mutableSymbol}
      setOptionChains={setOptionChains}
      setOptionChoices={setOptionChoices}
      symbolsUsed={symbolsUsed}
      setSymbolsUsed={setSymbolsUsed}
      data={data}
      marketOrderEnabled={marketOrderEnabled}
      setMarketOrderEnabled={setMarketOrderEnabled}
      marketOrder={marketOrder}
      dispatchMarketOrder={dispatchMarketOrder}
      limitOrderEnabled={limitOrderEnabled}
      setLimitOrderEnabled={setLimitOrderEnabled}
      limitOrder={limitOrder}
      dispatchLimitOrder={dispatchLimitOrder}
      candleBreakEnabled={candleBreakEnabled}
      setCandleBreakEnabled={setCandleBreakEnabled}
      candleBreak={candleBreak}
      dispatchCandleBreak={dispatchCandleBreak}
      setupFields={setupFields}
      dispatchSetUpDetails={dispatchSetUpDetails}
      defaultQtyBasisValue={defaultQtyBasisValue}
      lossLimit={lossLimit}
      dispatchLossLimit={dispatchLossLimit}
      lossLimitEnabled={lossLimitEnabled}
      setLossLimitEnabled={setLossLimitEnabled}
      preserveProfit={preserveProfit}
      dispatchPreserveProfit={dispatchPreserveProfit}
      preserveProfitEnabled={preserveProfitEnabled}
      setPreserveProfitEnabled={setPreserveProfitEnabled}
      positionPriceTrail={positionPriceTrail}
      dispatchPositionPriceTrail={dispatchPositionPriceTrail}
      positionPriceTrailEnabled={positionPriceTrailEnabled}
      setPositionPriceTrailEnabled={setPositionPriceTrailEnabled}
      underlyingPriceTrail={underlyingPriceTrail}
      dispatchUnderlyingPriceTrail={dispatchUnderlyingPriceTrail}
      underlyingPriceTrailEnabled={underlyingPriceTrailEnabled}
      setUnderlyingPriceTrailEnabled={setUnderlyingPriceTrailEnabled}
      candleTrail={candleTrail}
      dispatchCandleTrail={dispatchCandleTrail}
      candleTrailEnabled={candleTrailEnabled}
      setCandleTrailEnabled={setCandleTrailEnabled}
      grabCents={grabCents}
      dispatchGrabCents={dispatchGrabCents}
      grabCentsEnabled={grabCentsEnabled}
      setGrabCentsEnabled={setGrabCentsEnabled}
      grabCentsMode={grabCentsMode}
      setGrabCentsMode={setGrabCentsMode}
      greenToRedCandles={greenToRedCandles}
      dispatchGreenToRedCandles={dispatchGreenToRedCandles}
      greenToRedCandlesEnabled={greenToRedCandlesEnabled}
      setGreenToRedCandlesEnabled={setGreenToRedCandlesEnabled}
      greenToRedPositions={greenToRedPositions}
      dispatchGreenToRedPositions={dispatchGreenToRedPositions}
      greenToRedPositionsEnabled={greenToRedPositionsEnabled}
      setGreenToRedPositionsEnabled={setGreenToRedPositionsEnabled}
      breakPrice={breakPrice}
      dispatchBreakPrice={dispatchBreakPrice}
      breakPriceEnabled={breakPriceEnabled}
      setBreakPriceEnabled={setBreakPriceEnabled}
      positionBreakPrice={positionBreakPrice}
      dispatchPositionBreakPrice={dispatchPositionBreakPrice}
      positionBreakPriceEnabled={positionBreakPriceEnabled}
      setPositionBreakPriceEnabled={setPositionBreakPriceEnabled}
      candleMagnitude={candleMagnitude}
      dispatchCandleMagnitude={dispatchCandleMagnitude}
      candleMagnitudeEnabled={candleMagnitudeEnabled}
      setCandleMagnitudeEnabled={setCandleMagnitudeEnabled}
      ratchetBracket={ratchetBracket}
      dispatchRatchetBracket={dispatchRatchetBracket}
      ratchetBracketEnabled={ratchetBracketEnabled}
      setRatchetBracketEnabled={setRatchetBracketEnabled}
      symbolsRemaining={symbolsRemaining}
      setClickedSubmit={setClickedSubmit}
      clickedSubmit={clickedSubmit}
      setSubmitMessageDetails={setSubmitMessageDetails}
      configTitle={configTitle}
      storedConfigKey={storedConfigKey}
      isSavedConfigDirty={savedConfigChanged}
      submitMessageDetails={submitMessageDetails}
      setViewOptionManagementEnabled={setViewOptionManagementEnabled}
      deleteIndex={deleteIndex}
      index={index}
      setExpirationDates={setExpirationDates}
      maxOptionPriceBarrier={maxOptionPriceBarrier}
      setMaxOptionPriceBarrier={setMaxOptionPriceBarrier}
      minOptionPriceBarrier={minOptionPriceBarrier}
      setMinOptionPriceBarrier={setMinOptionPriceBarrier}
      optionChains={optionChains}
      tightSpreadPctEnabled={tightSpreadPctEnabled}
      setTightSpreadPctEnabled={setTightSpreadPctEnabled}
      tightSpreadPct={tightSpreadPct}
      dispatchTightSpreadPct={dispatchTightSpreadPct}
      optionPriceRangeEnabled={optionPriceRangeEnabled}
      setOptionPriceRangeEnabled={setOptionPriceRangeEnabled}
      optionPriceRange={optionPriceRange}
      dispatchOptionPriceRange={dispatchOptionPriceRange}
      expirationDates={expirationDates}
      optionChoices={optionChoices}
      optionShortCutsPackage={optionShortCutsPackage}
      selectAll={selectAll}
      callType={callType}
      putType={putType}
      setOtm1Enabled={setOtm1Enabled}
      setItm1Enabled={setItm1Enabled}
      setHugCurrentPriceEnabled={setHugCurrentPriceEnabled}
      dispatchItm1={dispatchItm1}
      dispatchOtm1={dispatchOtm1}
      hugCurrentPriceEnabled={hugCurrentPriceEnabled}
      otm1Enabled={otm1Enabled}
      itm1Enabled={itm1Enabled}
      tightSpreadCentsEnabled={tightSpreadCentsEnabled}
      setTightSpreadCentsEnabled={setTightSpreadCentsEnabled}
      tightSpreadCents={tightSpreadCents}
      dispatchTightSpreadCents={dispatchTightSpreadCents}
      qtyRangeEnabled={qtyRangeEnabled}
      setQtyRangeEnabled={setQtyRangeEnabled}
      qtyRange={qtyRange}
      dispatchQtyRange={dispatchQtyRange}
      dollarRangeEnabled={dollarRangeEnabled}
      setDollarRangeEnabled={setDollarRangeEnabled}
      dollarRange={dollarRange}
      dispatchDollarRange={dispatchDollarRange}
      priceIntersectsFirstCandleEnabled={priceIntersectsFirstCandleEnabled}
      setPriceIntersectsFirstCandleEnabled={
        setPriceIntersectsFirstCandleEnabled
      }
      priceIntersectsFirstCandle={priceIntersectsFirstCandle}
      dispatchPriceIntersectsFirstCandle={dispatchPriceIntersectsFirstCandle}
      emaIntersectsFirstCandleEnabled={emaIntersectsFirstCandleEnabled}
      setEmaIntersectsFirstCandleEnabled={setEmaIntersectsFirstCandleEnabled}
      emaIntersectsFirstCandle={emaIntersectsFirstCandle}
      dispatchEmaIntersectsFirstCandle={dispatchEmaIntersectsFirstCandle}
      timeOfDay={timeOfDay}
      dispatchTimeOfDay={dispatchTimeOfDay}
      timeOfDayEnabled={timeOfDayEnabled}
      setTimeOfDayEnabled={setTimeOfDayEnabled}
      ftfcFilter={ftfcFilter}
      dispatchFtfcFilter={dispatchFtfcFilter}
      ftfcFilterEnabled={ftfcFilterEnabled}
      setFtfcFilterEnabled={setFtfcFilterEnabled}
      buyOrSellOption={buyOrSellOption}
      userPreferences={userPreferences}
      otmEnabled={otm}
      itmEnabled={itm}
      notExpiringToday={notExpiringToday}
      setNotExpiringToday={setNotExpiringToday}
      restartSettings={restartSettings}
      setRestartSettings={setRestartSettings}
      atrTrailEnabled={atrTrailEnabled}
      setAtrTrailEnabled={setAtrTrailEnabled}
      atrTrail={atrTrail}
      dispatchAtrTrail={dispatchAtrTrail}
      mfeRetracementEnabled={mfeRetracementEnabled}
      setMfeRetracementEnabled={setMfeRetracementEnabled}
      mfeRetracement={mfeRetracement}
      dispatchMfeRetracement={dispatchMfeRetracement}
      underlyingPriceExitEnabled={underlyingPriceExitEnabled}
      setUnderlyingPriceExitEnabled={setUnderlyingPriceExitEnabled}
      underlyingPriceExit={underlyingPriceExit}
      dispatchUnderlyingPriceExit={dispatchUnderlyingPriceExit}
    />
    //                       EnterTradePlan={EnterTradePlan} handleEnterNow={handleEnterNow}
    //                   setFinishedRenderingOptionChain={setFinishedRenderingOptionChain}
    //                     finishedRenderingOptionChain={finishedRenderingOptionChain}
  );
}
